import React from 'react';
import { FaUsers, FaHeadset, FaDesktop, FaGem } from 'react-icons/fa';
import './Stats.css';

const Stats = () => {
  return (
  <section className="stats-section">
    <div className="stats-grid">
      <div className="stat-item" style={{animationDelay: '0s'}}>
        <div className="stat-icon">
          <FaUsers />
        </div>
        <div className="stat-number">1000+</div>
        <div className="stat-label">Professionals</div>
        <div className="stat-bar"></div>
      </div>
      
      <div className="stat-item" style={{animationDelay: '0.1s'}}>
        <div className="stat-icon">
          <FaHeadset />
        </div>
        <div className="stat-number">24/7</div>
        <div className="stat-label">Live Support</div>
        <div className="stat-bar"></div>
      </div>
      
      <div className="stat-item" style={{animationDelay: '0.2s'}}>
        <div className="stat-icon">
          <FaDesktop />
        </div>
        <div className="stat-number">50+</div>
        <div className="stat-label">Platforms Supported</div>
        <div className="stat-bar"></div>
      </div>
      
      <div className="stat-item" style={{animationDelay: '0.3s'}}>
        <div className="stat-icon">
          <FaGem />
        </div>
        <div className="stat-number">Unique</div>
        <div className="stat-label">Self-Written, No Analogues</div>
        <div className="stat-bar"></div>
      </div>
    </div>
  </section>
  );
};

export default Stats;
